import Spinner from "react-bootstrap/Spinner";

import { useNavigate } from "react-router-dom";

import { useEffect } from "react";
import { useState, useRef } from 'react';
import { useAuth } from '../lib/StAuthGiver';
import { getApiServer, getCurSiteId, callApi } from '../lib/Common_funcs.js';
import {
  FiMonitor, FiTablet, FiSmartphone, FiRefreshCw,
  FiExternalLink, FiCopy, FiCheck, FiUploadCloud, FiInfo,
} from 'react-icons/fi';

const WhichEnv =
  process.env.REACT_APP_TURBO_ENV === undefined ? "aws" : "staging";
const Tdebug = WhichEnv != "aws";

const StSitePreview = () => {
  const { loginAction } = useAuth();
  const { logOut } = useAuth();

  const [loading, setLoading] = useState(true);
  const [siteName, setSiteName] = useState("");
  const [siteUrl, setSiteURL] = useState("/upload_site.png");
  const [siteReloads, setSiteReloads] = useState(0);
  const [siteAccessible, setSiteAccessible] = useState(false);
  const [viewport, setViewport] = useState('desktop');
  const [copied, setCopied] = useState(false);

  const navigate = useNavigate();
  const curSiteId = getCurSiteId();

  const getViewportWidth = () => (viewport === 'mobile' ? '390px' : viewport === 'tablet' ? '768px' : '100%');

  const handleCopy = () => {
    navigator.clipboard.writeText(siteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const isUrlLive = async (host) => {
    const min = 1000000000;
    const max = 9999999999;
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

        try {

		//const rc = await fetch(`${host}/index.html?turbonckey=${randomNumber}`, {
			//method: 'GET',
		//});

            const rc = await fetch(getApiServer() + '/isl?url=' + encodeURIComponent(host), {
                method: 'GET',
            });     

            Tdebug && console.log(rc);
            Tdebug && console.log(rc.ok);

      const response = await rc.text();
      Tdebug && console.log("Logging response now...");

      if ((rc.statusCode = 200)) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      console.log("catch for fetch try");
      return false;
    }
  };

  const reloadSite = () => {
    setSiteReloads(siteReloads + 1);
  };

  const getIframeUrl = () => {
    const randomKey = `${Date.now()}-${Math.random()
      .toString(36)
      .substring(2, 15)}`;
    const randomUrl = siteUrl + "/index.html?turbonckey=" + randomKey;
    Tdebug && console.log(randomUrl);
    console.log("RandomURL: ", randomUrl);
    return randomUrl;
  };

  useEffect(() => {
    const fetchData = async () => {
      // const curSiteId = getCurSiteId();
      const rcJson = await callApi("/sites/" + curSiteId, "GET", {}, {});

      Tdebug && console.log(rcJson);

      console.log(rcJson);
      setSiteName(rcJson.respBody.siteName);
      const rc_siteUrl =
        "https://" +
        rcJson.respBody.siteName +
        `.${process.env.REACT_APP_HOST_DOMAIN}`;
      setSiteURL(rc_siteUrl);

      isUrlLive(rc_siteUrl)
        .then((result) => {
          Tdebug &&
            console.log("isUrlLive returned, site status is: " + result);
          setSiteAccessible(result);
        })
        .catch((err) => {
          Tdebug && console.log("isUrlLive error!");
        });

      Tdebug && console.log("Set loading to false as we have the information");
      setLoading(false);
    };
    fetchData();
    console.log("sitenmae", siteName);
    console.log(siteUrl);
  }, []);

  useEffect(() => {
    Tdebug &&
      console.log(
        "useEffect[siteAccessible] : Site accessible value is: " +
          siteAccessible
      );
  }, [siteAccessible]);

  Tdebug && console.log("Site accessible is: " + siteAccessible);

  if (loading) {
    return (
      <div className="app-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center' }}>
          <Spinner animation="border" style={{ width: '2rem', height: '2rem', color: 'var(--accent-primary)' }} />
          <div style={{ marginTop: '12px', fontSize: '13px', color: 'var(--text-tertiary)' }}>Loading...</div>
        </div>
      </div>
    );
  }

  const btnBase = {
    display: 'flex', alignItems: 'center', gap: '6px',
    border: 'none', borderRadius: 'var(--radius-md)', fontSize: '13px',
    fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', transition: 'all 150ms ease',
  };

  return (
    <div className="app-content animate-in" style={{ display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px', flexWrap: 'wrap' }}>
        <div>
          <h1 className="dashboard-title">Site Preview</h1>
          <p className="dashboard-subtitle">Preview your website as visitors will see it</p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          {/* Viewport toggle */}
          <div style={{ display: 'flex', border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)', overflow: 'hidden' }}>
            {[
              { id: 'desktop', icon: FiMonitor },
              { id: 'tablet', icon: FiTablet },
              { id: 'mobile', icon: FiSmartphone },
            ].map((v, i) => (
              <button
                key={v.id}
                onClick={() => setViewport(v.id)}
                title={v.id.charAt(0).toUpperCase() + v.id.slice(1)}
                style={{
                  padding: '8px 12px', border: 'none', cursor: 'pointer',
                  borderLeft: i > 0 ? '1px solid var(--border-color)' : 'none',
                  background: viewport === v.id ? 'var(--accent-soft)' : 'var(--bg-secondary)',
                  color: viewport === v.id ? 'var(--accent-primary)' : 'var(--text-secondary)',
                }}
              >
                <v.icon size={16} />
              </button>
            ))}
          </div>

          <button
            onClick={() => reloadSite()}
            style={{ ...btnBase, padding: '8px 14px', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: 'var(--text-primary)' }}
          >
            <FiRefreshCw size={14} /> Refresh
          </button>

          <a
            href={siteUrl} target="_blank" rel="noopener noreferrer"
            style={{ ...btnBase, padding: '8px 14px', background: 'var(--accent-gradient)', color: 'white', textDecoration: 'none' }}
          >
            <FiExternalLink size={14} /> Open Live Site
          </a>
        </div>
      </div>

      {/* Info banner */}
      <div style={{
        display: 'flex', alignItems: 'flex-start', gap: '10px',
        background: 'var(--accent-soft)', border: '1px solid rgba(37,99,235,0.15)',
        borderRadius: 'var(--radius-md)', padding: '12px 16px', marginBottom: '16px',
        fontSize: '13px', color: 'var(--text-secondary)',
      }}>
        <FiInfo size={16} style={{ color: 'var(--accent-primary)', flexShrink: 0, marginTop: '1px' }} />
        <span>When you switch or update templates, it may take a few minutes for changes to reflect below. Click Refresh if changes aren't applied.</span>
      </div>

      {/* URL bar */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        padding: '8px 12px', background: 'var(--bg-tertiary)',
        borderRadius: 'var(--radius-md)', marginBottom: '16px',
      }}>
        <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: siteAccessible ? 'var(--success)' : 'var(--text-tertiary)', flexShrink: 0 }} />
        <code style={{ flex: 1, fontSize: '13px', color: 'var(--text-secondary)', fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {siteUrl}
        </code>
        <button
          onClick={handleCopy}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px', border: 'none', background: 'transparent', cursor: 'pointer', borderRadius: 'var(--radius-sm)', color: copied ? 'var(--success)' : 'var(--text-secondary)', flexShrink: 0 }}
          title="Copy URL"
        >
          {copied ? <FiCheck size={14} /> : <FiCopy size={14} />}
        </button>
      </div>

      {/* Preview frame */}
      <div style={{
        background: 'var(--bg-tertiary)', borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--border-color)', overflow: 'hidden',
        display: 'flex', justifyContent: 'center',
        padding: viewport !== 'desktop' ? '24px' : 0,
        minHeight: '70vh',
      }}>
        <div style={{
          width: getViewportWidth(), background: 'white',
          borderRadius: viewport !== 'desktop' ? 'var(--radius-lg)' : 0,
          boxShadow: viewport !== 'desktop' ? 'var(--shadow-lg)' : 'none',
          overflow: 'hidden', transition: 'width 200ms ease',
          display: 'flex', flexDirection: 'column',
        }}>
          {/* Mock browser chrome for non-desktop */}
          {viewport !== 'desktop' && (
            <div style={{
              height: '30px', background: 'var(--bg-secondary)',
              borderBottom: '1px solid var(--border-color)',
              display: 'flex', alignItems: 'center', padding: '0 12px', gap: '6px', flexShrink: 0,
            }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#ff5f57' }} />
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#febc2e' }} />
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#28c840' }} />
            </div>
          )}

          {siteAccessible ? (
            <iframe
              key={siteReloads}
              src={getIframeUrl()}
              title="Your Website"
              referrerPolicy="no-referrer"
              style={{ border: 'none', width: '100%', flex: 1, minHeight: 0 }}
            />
          ) : (
            <div style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '48px',
            }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: 'var(--bg-tertiary)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', marginBottom: '16px',
              }}>
                <FiUploadCloud size={28} style={{ color: 'var(--text-tertiary)' }} />
              </div>
              <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '6px', color: '#171717' }}>No Content Available</h3>
              <p style={{ fontSize: '13px', color: '#71717a', marginBottom: '20px', maxWidth: '360px' }}>
                Your website content will appear here once you upload files or create pages.
              </p>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={() => navigate('/' + curSiteId + '/sites')}
                  style={{ ...btnBase, padding: '9px 18px', background: 'var(--accent-gradient)', color: 'white' }}
                >
                  Upload Files
                </button>
                <button
                  onClick={() => navigate('/' + curSiteId + '/editor')}
                  style={{ ...btnBase, padding: '9px 18px', background: 'transparent', border: '1px solid var(--border-color)', color: 'var(--text-primary)' }}
                >
                  Browse Templates
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default StSitePreview;
